import styled from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';
import { FONT_STACK } from '../../styles/constants';
import { onMobile } from '../../styles/onMobile';

export const STANDARD_WIDTH_APPOINTMENT_LIGHTBOX = '1089px';

export const EmbeddedLightbox = styled.iframe<{ height: string }>`
  border: none;
  height: ${props => props.height ?? '600px'};
  outline: none;
  width: 100%;

  ${onMobile} {
    flex: 1;
  }
`;

export const LightboxHeader = styled.h2`
  ${FONT_STACK};
  color: ${ThemeColours.black};
  font-size: 22px;
  font-weight: 700;
  line-height: 1.27em;
  margin: 0;
  margin-bottom: 16px;
`;
